import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Buefy from 'buefy'
import axios from "axios";
import VueRouter from 'vue-router'
import qs from "qs"
// import 'lib-flexible'
// import 'buefy/dist/buefy.css'


Vue.use(Buefy)
Vue.use(VueRouter)
// Vue.use(Sass)
// Vue.use(loader)
Vue.prototype.$axios = axios;
Vue.prototype.$qs = qs;
Vue.config.productionTip = false


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
